import React, { Component } from "react";
import Avatar from "./images/avatar.png";
import { HashRouter as Router, Route, Link, NavLink } from "react-router-dom";
import "./assets/css/main.css";

import About from "./components/About";
import Resume from "./components/Resume";
import Projects from "./components/Projects";
import Contact from "./components/Contact";

class App extends Component {
  componentDidMount() {
    document.title = "Ryan Pearlman";
  }

  render() {
    return (
      <Router>
        <div id="wrapper">
          <Route exact path="/" component={About} />
          <Route path="/resume" component={Resume} />
          <Route path="/projects" component={Projects} />
          <Route path="/contact" component={Contact} />

          {/* <!-- Header --> */}
          <header id="header">
            <h1>
              <a href="index.html">Ryan Pearlman</a>
            </h1>
            <nav class="links">
              <ul>
                <li>
                  <NavLink to="/">About</NavLink>
                </li>
                {/* <li>
                  <NavLink to="/resume">Resume</NavLink>
                </li> */}
                {/* <li>
                  <NavLink to="/projects">Projects</NavLink>
                </li> */}
                <li>
                  <NavLink to="/contact">Contact</NavLink>
                </li>
              </ul>
            </nav>
            {/* <nav class="main">
              <ul>
                <li class="search">
                  <a class="fa-search" href="#search">
                    Search
                  </a>
                  <form id="search" method="get" action="#">
                    <input type="text" name="query" placeholder="Search" />
                  </form>
                </li>
                <li class="menu">
                  <a class="fa-bars" href="#menu">
                    Menu
                  </a>
                </li>
              </ul>
            </nav> */}
          </header>

          {/* <!-- Menu --> */}
          <section id="menu">
            {/* <!-- Search --> */}
            <section>
              <form class="search" method="get" action="#">
                <input type="text" name="query" placeholder="Search" />
              </form>
            </section>

            {/* <!-- Links --> */}
            <section>
              <ul class="links">
                <li>
                  <a href="#">
                    <h3>Lorem ipsum</h3>
                    <p>Feugiat tempus veroeros dolor</p>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <h3>Dolor sit amet</h3>
                    <p>Sed vitae justo condimentum</p>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <h3>Feugiat veroeros</h3>
                    <p>Phasellus sed ultricies mi congue</p>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <h3>Etiam sed consequat</h3>
                    <p>Porta lectus amet ultricies</p>
                  </a>
                </li>
              </ul>
            </section>

            {/* <!-- Actions --> */}
            <section>
              <ul class="actions stacked">
                <li>
                  <a href="#" class="button large fit">
                    Log In
                  </a>
                </li>
              </ul>
            </section>
          </section>

          {/* <!-- Sidebar --> */}
          <section id="sidebar">
            {/* <!-- Intro --> */}
            <section id="intro">
              <a href="#" class="logo">
                <img src={Avatar} alt="" />
              </a>
              <header>
                <h1>Ryan Pearlman</h1>
                <p>
                  <a href="mailto:pearlman.ryan@gmail.com">
                    pearlman.ryan@gmail.com
                  </a>
                </p>
              </header>
            </section>

            {/* <!-- About --> */}
            {/* <section class="blurb">
              <h2>About</h2>
              <p>
                As an undergraduate student at UT Dallas Computer Science, I'm a
                full-time student; but that doesn't stop me from pursuing
                personal and professional projects.
                <br />
                <br />
                In 2017, I started Ensign Consultants, a consulting company
                focused on Website Development, Custom Web Application
                Development, and Digital Marketing Services.
              </p>
              <ul class="actions">
                <li>
                  <a href="#" class="button">
                    Learn More
                  </a>
                </li>
              </ul>
            </section> */}

            {/* <!-- Footer --> */}
            <section id="footer">
              <ul class="icons">
                <li>
                  <a
                    href="https://www.linkedin.com/in/ryan-pearlman-511344a6/"
                    class="fa-linkedin"
                    target="_blank"
                  >
                    <span class="label">LinkedIn</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com"
                    class="fa-twitter"
                    target="_blank"
                  >
                    <span class="label">Twitter</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/ryan.pearlman.73"
                    class="fa-facebook"
                    target="_blank"
                  >
                    <span class="label">Facebook</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com"
                    class="fa-instagram"
                    target="_blank"
                  >
                    <span class="label">Instagram</span>
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:pearlman.ryan@gmail.com"
                    class="fa-envelope"
                    target="_blank"
                  >
                    <span class="label">Email</span>
                  </a>
                </li>
              </ul>
              <p class="copyright">
                &copy; Ryan Pearlman 2021{" "}
                <a href="https://www.pearlmanryan.com">pearlmanryan.com</a>
              </p>
            </section>
          </section>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js